<pmv-fieldset [header]="header" *ngIf="header; else nofieldset">
  <ng-container *ngTemplateOutlet="treeview"></ng-container>
</pmv-fieldset>

<ng-template #nofieldset>
  <ng-container *ngTemplateOutlet="treeview"></ng-container>
</ng-template>

<ng-template #treeview>
  <div *ngIf="dropdown; then drop; else tree"></div>
  <ng-template #drop>
    <div *ngIf="showSelectedTree; then selectedTreeDropTemplate; else normalTreeDropTemplate"></div>
    <ng-template #selectedTreeDropTemplate>
      <ngx-dropdown-treeview [config]="_config" [items]="selectedTree" [headerTemplate]="customHeaderTemplate" [itemTemplate]="customItemTemplate"
        [class.loading]="isLoading" buttonClass="form-control"></ngx-dropdown-treeview>
    </ng-template>
    <ng-template #normalTreeDropTemplate>
      <ngx-dropdown-treeview [config]="_config" [items]="_items" (selectedChange)="onSelectedChange($event)" [headerTemplate]="customHeaderTemplate"
        [itemTemplate]="customItemTemplate" [class.loading]="isLoading" buttonClass="form-control"></ngx-dropdown-treeview>
    </ng-template>
  </ng-template>
  <ng-template #tree>
    <div *ngIf="showSelectedTree; then selectedTreeTemplate; else normalTreeTemplate"></div>
    <ng-template #selectedTreeTemplate>
      <ngx-treeview [config]="_config" [items]="selectedTree" [headerTemplate]="customHeaderTemplate" [itemTemplate]="customItemTemplate"
        [class.loading]="isLoading"></ngx-treeview>
    </ng-template>
    <ng-template #normalTreeTemplate>
      <ngx-treeview [config]="_config" [items]="_items" (selectedChange)="onSelectedChange($event)" [headerTemplate]="customHeaderTemplate"
        [itemTemplate]="customItemTemplate" [class.loading]="isLoading"></ngx-treeview>
    </ng-template>
  </ng-template>
</ng-template>

<ng-template #customItemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <div class="form-check">
      <i *ngIf="item.children" (click)="handleCollapseExpand(item, onCollapseExpand)" aria-hidden="true" class="fa" [class.fa-caret-right]="item.collapsed"
        [class.fa-caret-down]="!item.collapsed"></i>
      <ng-container *ngIf="!noInput && (showRootsInputs || !isRoot(item))">
        <div *ngIf="selectOnlyOne; then inputRadio; else inputCheckbox"></div>
        <ng-template #inputRadio>
          <input *ngIf="(!item.children || (config.decoupleChildFromParent && showParentsInputs))" style="margin: 2px 0 0 15px" [(ngModel)]="selectedRadioButton" (ngModelChange)="selectRadioButton($event, onCheckedChange)"
            type="radio" class="form-check-input" [value]="item.value" [name]="identifier" [disabled]="item.disabled || disabled"
          />
        </ng-template>
        <ng-template #inputCheckbox>
          <input *ngIf="(!item.children || showParentsInputs) && showCheckbox" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
            type="checkbox" class="form-check-input" [disabled]="item.disabled || disabled" [indeterminate]="item.indeterminate"
          />
        </ng-template>
      </ng-container>
      <label [style.color]="colorFn && colorFn(item.value)" class="form-check-label" (click)="handleLabelClick(item, onCheckedChange, onCollapseExpand)">
        {{item.text}}
      </label>
      <div class="line-separator" [style.display]="!showLine ? 'none' : null"></div>
      <div class="value-right" *ngIf="valuesRelative.get(item.value)">
        {{valuesRelative.get(item.value)}}
      </div>
      <div class="action-icon-container" *ngIf="!item.children || showParentsActions">
        <span *ngFor="let action of actions" class="action-icon" [class.is-hidden]="action.isHidden && action.isHidden(item.value, null)"
          (click)="actionEvent(action, item.value)" [pTooltip]="action.title" tooltipPosition="left">
          <span [class]="getIcon(action, item.value)"></span>
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customHeaderTemplate let-cfg="config" let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange"
  let-onFilterTextChange="onFilterTextChange">
  <ng-container *ngIf="cfg">
    <div *ngIf="cfg.hasFilter" class="row row-filter">
      <div class="col-12">
        <input class="form-control" type="text" [placeholder]="i18n.getFilterPlaceholder()" [(ngModel)]="filterText" (ngModelChange)="onFilterTextChange($event)"
        />
      </div>
    </div>
    <div>
      <div *ngIf="(cfg.hasAllCheckBox && !selectOnlyOne) || cfg.hasCollapseExpand || cfg.canShowSelectedTree" class="row row-all">
        <div class="col-12">
          <div class="form-check">
            <input *ngIf="cfg.hasAllCheckBox && !selectOnlyOne" type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange($event)"
              [indeterminate]="item.indeterminate" />
            <label *ngIf="cfg.hasAllCheckBox && !selectOnlyOne" class="form-check-label">
              {{ i18n.getAllCheckboxText() }}
            </label>
            <input *ngIf="cfg.canShowSelectedTree" type="checkbox" class="form-check-input" [(ngModel)]="showSelectedTree" />
            <label *ngIf="cfg.canShowSelectedTree" class="form-check-label">
              Mostrar somente itens selecionados
            </label>
            <label #labelCollapse *ngIf="cfg.hasCollapseExpand" class="pull-right form-check-label" [class.hidden]="hideCollapseExpandIcon"
              (click)="onCollapseExpand()">
              <i [title]="i18n.getTooltipCollapseExpandText(item.collapsed)" aria-hidden="true" class="fa" [class.fa-expand]="item.collapsed"
                [class.fa-compress]="!item.collapsed"></i>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="cfg.hasDivider" class="dropdown-divider"></div>
    </div>
  </ng-container>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.TreeviewComponent.html